import { render } from "./TableWithStatus.vue?vue&type=template&id=8df6ec98"
import script from "./TableWithStatus.vue?vue&type=script&lang=js"
export * from "./TableWithStatus.vue?vue&type=script&lang=js"

import "./TableWithStatus.vue?vue&type=style&index=0&id=8df6ec98&lang=css"
script.render = render

export default script